<script>
    import CourseBuyableItem from './CourseBuyableItem.vue';

    export default {
        components: {CourseBuyableItem},
        props: ['courseprop'],
        data() {
            return {
                selected: '',
                course: {},
                lessonPackages: {},
                subscriptions: {},
            }
        },
        mounted() {
            this.course = this.courseprop;
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/course/CourseBuyable.vue